import { DueDiligenceService } from '@/modules/global-settings/onboarder/services/due-diligence.service';
import { make } from 'vuex-pathify';
import Logger from '@/lib/logger';
// Create a new instance of the DueDiligenceService class
const dueDiligenceService = new DueDiligenceService();
// Define the state of the DueDiligence module
export const state = {
  dueDiligenceTypes: [],
  dueDiligenceGuides: []
};
// Define the mutations of the DueDiligence module
export const mutations = {
  ...make.mutations(state)
};
// Define the actions of the DueDiligence module
export const actions = {
  /**
   * Fetch due diligence types
   * @param {Object} object - Vuex context
   * @returns {Array} Array of due diligence types
   * @private This will set the values in state after fetching
   */
  async fetchDueDiligenceTypes({ commit }) {
    try {
      const { data } = await dueDiligenceService.fetchDueDiligenceTypes();
      commit('SET_DUE_DILIGENCE_TYPES', data);
      return data;
    } catch (error) {
      Logger.error('fetching due diligence');
      throw error;
    }
  },

  /**
   * Update due diligence types
   * @param {Object} object - Vuex context
   * @param {Object} updates - Object containing the updates
   * @returns {Array} Array of due diligence types
   * @private This will set the values in state after updating
   */
  async updateDueDiligenceType({ dispatch }, updates) {
    try {
      const { data } = await dueDiligenceService.updateDueDiligenceType(
        updates
      );
      dispatch('fetchDueDiligenceTypes');
      return data;
    } catch (error) {
      Logger.error('updating due diligence');
      throw error;
    }
  },

  /**
   * Fetch due diligence guides
   * @param {Object} object - Vuex context
   * @returns {Array} Array of due diligence guides
   * @private This will set the values in state after fetching
   */
  async fetchDueDiligenceGuides({ commit }) {
    try {
      const { data } = await dueDiligenceService.fetchDueDiligenceGuides();
      commit('SET_DUE_DILIGENCE_GUIDES', data);
      return data;
    } catch (error) {
      Logger.error('fetching due diligence guide');
      throw error;
    }
  },

  /**
   * Update due diligence guides
   * @param {Object} object - Vuex context
   * @param {Object} updates - Object containing the updates
   * @returns {number} Status code
   * @private This will set the values in state after updating
   */
  async updateDiligenceGuide({ dispatch }, updates) {
    try {
      const { status } = await dueDiligenceService.updateDiligenceGuide(
        updates
      );
      dispatch('fetchDueDiligenceGuides');
      return status;
    } catch (error) {
      Logger.error('updating due diligence guide');
      throw error;
    }
  }
};
// Define the getters of the DueDiligence module
export const getters = {
  ...make.getters(state),
  getActiveDueDiligenceTypes(state) {
    return state.dueDiligenceTypes.filter((d) => d.active == true);
  },
  getDueDiligenceById: (state) => (id) =>
    state.dueDiligenceTypes.find((type) => type.id == id)
};
